export default "__VITE_ASSET__qGro6onn__"